<template>
  <div>
    <model-table
      title="Employee Job Types"
      add-label="Employee Job Type"
      edit-label="Edit"
      submodel
      :filter-by-data-array="userEmployeeJobTypesForSite"
      :collection="user.userEmployeeJobTypes"
      :columns="[
        { name: 'name', field: userEmployeeJobType => userEmployeeJobType.employeeJobType.name },
        { name: 'hourlyRate', component: 'money', field: userEmployeeJobType => userEmployeeJobType.hourlyRate, style: userEmployeeJobType => userEmployeeJobType.hasHourlyRateOverride ? 'color: blue' : '' },
        { name: 'defaultHourlyRate', component: 'money', field: userEmployeeJobType => userEmployeeJobType.employeeJobType.hourlyRate },
        { name: 'default', field: 'default', component: 'checkbox' },
        { name: 'actions', align: 'right' }
      ]"
      :show-add="$isPermitted($permissions.Team.Manage)"
      @add="$refs.assignUserEmployeeJobTypes.show()"
    >
      <user-employee-job-type-form
        :user="user"
        submodel
        @on-close="userEmployeeJobType => checkForDefault(userEmployeeJobType)"
      />
    </model-table>

    <assign-user-employee-job-types
      ref="assignUserEmployeeJobTypes"
      :user="user"
    />
  </div>
</template>

<script>
import User from 'src/models/user/User'
import ModelTable from 'src/modules/admin/components/ModelTable'
import AssignUserEmployeeJobTypes from 'src/modules/admin/user/AssignUserEmployeeJobTypes'
import UserEmployeeJobTypeForm from 'src/modules/admin/user/UserEmployeeJobTypeForm'

export default {
  name: 'UserEmployeeJobTypesTable',
  components: {
    ModelTable,
    AssignUserEmployeeJobTypes,
    UserEmployeeJobTypeForm
  },
  configuration: ['currentSite'],
  props: {
    user: {
      type: User,
      required: true
    }
  },
  computed: {
    userEmployeeJobTypesForSite () {
      const userEmployeeJobTypesForSite = _.filter(this.user.userEmployeeJobTypes.data, userEmployeeJobType => {
        return userEmployeeJobType.employeeJobType?.siteId === this.currentSite.id
      })

      return userEmployeeJobTypesForSite
    }
  },
  methods: {
    checkForDefault (updatedUserEmployeeJobType) {
      if (updatedUserEmployeeJobType.default) {
        _.each(this.userEmployeeJobTypesForSite, userEmployeeJobType => {
          if (userEmployeeJobType.id !== updatedUserEmployeeJobType.id && userEmployeeJobType.default) {
            userEmployeeJobType.default = false
          }
        })
      }
    }
  }
}
</script>
